// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__OE0FY","list":"BalanceDue_list__yCBwt","listRow":"BalanceDue_listRow__2KbMU","total":"BalanceDue_total__24TVz"};